import './index.css';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useDropzone } from 'react-dropzone';
import classnames from 'classnames';
import { VSpacing } from '@hh.ru/magritte-ui-spacing';
import { FileViewWithPreview } from './FileViewWithPreview.js';
import { Placeholder } from './Placeholder.js';
import { useDropActions } from './useDropActions.js';
import { useDropButtons } from './useDropButtons.js';
import { getAvaliableFileTypes, getUploadIcon, DEFAULT_ACCEPT, RenderFileInfoDefault } from './utils.js';
import { s as styles } from './upload-D19YV3Gb.js';
import './FileView.js';
import '@hh.ru/magritte-ui-action';
import '@hh.ru/magritte-ui-avatar';
import '@hh.ru/magritte-ui-divider';
import '@hh.ru/magritte-ui-icon/icon';
import '@hh.ru/magritte-ui-loader';
import './FileName.js';
import './useFilePreview.js';
import 'react';
import '@hh.ru/magritte-ui-breakpoint';
import '@hh.ru/magritte-ui-typography';

const MultiUpload = ({ files, trls, size, accept = DEFAULT_ACCEPT, selectFileButton: _selectFileButton, renderFileInfo = RenderFileInfoDefault, onDropAccepted: onDropAcceptedExternal, onDropRejected: onDropRejectedExternal, onFileDelete: onFileDeleteExternal, 'aria-label': ariaLabel, ...dropzoneProps }) => {
    const uploadType = getAvaliableFileTypes(accept);
    const { onDropAccepted, onDropRejected, onFileDelete } = useDropActions({
        onDropAccepted: onDropAcceptedExternal,
        onDropRejected: onDropRejectedExternal,
        onFileDelete: onFileDeleteExternal,
    });
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        ...dropzoneProps,
        accept,
        onDropAccepted,
        onDropRejected,
        multiple: true,
    });
    const { selectFileButton } = useDropButtons({ selectFileButton: _selectFileButton });
    return (jsxs(Fragment, { children: [jsxs("div", { className: classnames(styles.root, styles[`root_${size}`], { [styles.dragActive]: isDragActive }), ...getRootProps(), "data-qa": "magritte-multiple-upload", children: [jsx("input", { ...getInputProps(), "data-qa": "magritte-multiple-upload-input" }), jsx("div", { className: styles.background }), jsxs("div", { className: styles.body, children: [getUploadIcon(uploadType, undefined, false), jsx(VSpacing, { default: 16 }), jsx(Placeholder, { trls: trls, selectFileButton: selectFileButton })] })] }), files.length > 0 && (jsx("div", { className: styles.fileList, children: files.map((loadedFile, indexFile) => {
                    return (jsx(FileViewWithPreview, { loadedFile: loadedFile, renderFileInfo: renderFileInfo, onFileDelete: (event) => {
                            onFileDelete(event, loadedFile, indexFile);
                        }, "aria-label": ariaLabel || '', isLast: files.length - 1 === indexFile }, loadedFile.data.name));
                }) }))] }));
};

export { MultiUpload };
//# sourceMappingURL=MultiUpload.js.map
